import {
	CreateBase,
	Form,
	Toolbar,
	useGetIdentity,
	useTranslate
} from 'react-admin';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { GoToListButton } from '../../../components';
import { ICONS_BY_OBJECT, OBJECTS_TYPES } from '../../../constants';
import { PropertyType } from '../../../types';
import { ApartmentInputs } from '../ApartmentInputs';

export const ApartmentCreate = () => {
	const { identity } = useGetIdentity();
	const translate = useTranslate();

	const Icon = ICONS_BY_OBJECT[OBJECTS_TYPES.APARTMENTS];

	return (
		<Box mt={3}>
			<GoToListButton />
			<CreateBase
				resource={OBJECTS_TYPES.PROPERTIES}
				redirect={() => `objects/${OBJECTS_TYPES.APARTMENTS}`}
				transform={(data: PropertyType) => ({
					...data,
					property_type: OBJECTS_TYPES.APARTMENTS
				})}
			>
				<Box mt={2} display="flex">
					<Box flex="1">
						<Stack mb={1} direction="row" alignItems="center">
							<Icon fontSize="large" />
							<Typography ml={1} variant="h4">
								{translate('objects.items.apartment')}
							</Typography>
						</Stack>
						<Form defaultValues={{ sales_id: identity?.id }}>
							<Card>
								<CardContent sx={{ padding: 0 }}>
									<ApartmentInputs />
								</CardContent>
								<Toolbar />
							</Card>
						</Form>
					</Box>
				</Box>
			</CreateBase>
		</Box>
	);
};
